import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=75bbbee6&scoped=true&"
import script from "./PageDashboard.vue?vue&type=script&lang=ts&"
export * from "./PageDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbbee6",
  null
  
)

export default component.exports